export { SredProjects, SredHome } from './pages';
